/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { forwardRef, HTMLAttributes } from "react";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";

import { I18nChildContext, t, useI18n } from "@bookingcom/lingojs-react";
import { Badge } from "@bookingcom/bui-react";
import GeniusBadge from "@bookingcom/bui-assets-react/genius/GeniusBadge";
import { FlightBadgeVariant, UIFlightBadge } from "@flights/types";
import { FlightCardBadgePopoverWrapper } from "./FlightCardBadgePopoverWrapper";
import styles from "./FlightCardBadge.module.css";
import { FlightCardBadgeBottomSheetWrapper } from "./FlightCardBadgeBottomSheetWrapper";
import useUserAgent from "../../../../hooks/useUserAgent";
import { splitBoundsTrackingStorage } from "../../../../utils/experiments/funnel/flights_split_bounds_us";

type Props = {
  style?: typeof FlightBadgeVariant[keyof typeof FlightBadgeVariant];
  alternative?: boolean;
  text?: string;
  attributes?: HTMLAttributes<HTMLDivElement>;
  type?: UIFlightBadge["type"];
  hover?: {
    title: string;
    text: string;
  };
  isInteractive?: boolean;
  /* start - flights_split_bounds_us */
  /* ONLY FOR TRACKING, REMOVE WHEN CLEANED UP */
  flightToken?: string;
  /* end - flights_split_bounds_us */
};

export const FlightCardBadge = forwardRef<HTMLSpanElement, Props>((props, ref) => {
  const {
    style = FlightBadgeVariant.PRIMARY,
    alternative = false,
    text,
    hover: _hover,
    attributes,
    isInteractive = true,
    flightToken
  } = props;
  const i18n = useI18n() as I18nChildContext;

  const getVariant = (style: typeof FlightBadgeVariant[keyof typeof FlightBadgeVariant]) =>
    style === FlightBadgeVariant.BRAND_PRIMARY
      ? "brand-primary"
      : style === FlightBadgeVariant.PRIMARY
      ? "brand-primary"
      : style === FlightBadgeVariant.ACCENT
      ? "accent"
      : style === FlightBadgeVariant.CALLOUT
      ? "callout"
      : style === FlightBadgeVariant.CONSTRUCTIVE
      ? "constructive"
      : style === FlightBadgeVariant.DESTRUCTIVE
      ? "destructive"
      : style === FlightBadgeVariant.MEDIA
      ? "media"
      : style === FlightBadgeVariant.OUTLINE
      ? "outline"
      : style === FlightBadgeVariant.GENIUS
      ? "brand-genius-primary"
      : undefined;

  const { isMobile } = useUserAgent();
  const WrapperComponent = isMobile ? FlightCardBadgeBottomSheetWrapper : FlightCardBadgePopoverWrapper;

  const hover = isInteractive ? _hover : undefined;

  if (style === FlightBadgeVariant.GENIUS) {
    flightToken && splitBoundsTrackingStorage.addValue(flightToken, "genius");
    return (
      <WrapperComponent hover={hover}>
        <span
          className={styles.geniusBadge}
          aria-label={i18n.trans(t("a11y_flights_search_results_card_genius_label"))}
          role="img"
        >
          <GeniusBadge />
        </span>
      </WrapperComponent>
    );
  }

  if (isNil(text) || isEmpty(text)) return null;

  return (
    <WrapperComponent hover={hover}>
      <Badge
        className={`${getVariant(style)} ${styles.badge}`}
        text={text}
        variant={getVariant(style)}
        alternative={alternative}
        attributes={{ ref, "aria-hidden": attributes?.["aria-hidden"] }}
      />
    </WrapperComponent>
  );
});

FlightCardBadge.displayName = "FlightCardBadge";
